import React from "react"
import FetchNews from "./Components/FetchNews"

function App()
{

  return(
    <FetchNews/>  
  )
}

export default App